import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import * as D from 'ApplicationEntry/models/ProductsRiders/Disability/GroupDisability';
import States from 'ApplicationEntry/models/States';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import '.././Ordinary/Disability.sass';
import './../ProductRiders.sass';
import * as ErrorMessages from '../../ErrorMessages';
import {EmptyString} from 'Core/models/EmptyString';
import {CaseNumber, UnassignedCaseNumber} from 'ApplicationEntry/models/CaseNumber';
import PackageSelect from '../PackageSelect';
import {CaseDetails, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import * as DActions from 'ApplicationEntry/ducks/ProductsRiders/disability';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {getSitusStatefromCaseNumber} from 'ApplicationEntry/ducks/caseDetails';
import {getBillingModefromCaseNumber} from 'ApplicationEntry/ducks/caseDetails';

type GroupDisabilityProps = {
  caseDetails: CaseDetails;
  disability: D.GroupDisability;
};

const GroupDisability = ({caseDetails, disability}: GroupDisabilityProps) => {
  const dispatch = useDispatch();
  const {
    plan,
    type,
    issueType,
    accident,
    sickness,
    benefitPeriod,
    monthlySalary,
    gcroprRider,
    oadr1Rider,
    fmdr1Rider,
    ibdr1Rider,
    sadrRider,
    packageSource,
    replacement,
    policyNumber,
    section125,
    calculatedPremium,
    cwa,
    monthlyBenefit,
    jStamp,
    packageSourceList,
    mentalNervousExclusion,
    isGvdiPortable,
  } = disability;

  const caseNumber: CaseNumber = matchCaseDetailsByType({
    Group: groupApplication => groupApplication.caseNumber,
    _: () => new UnassignedCaseNumber(new EmptyString()),
  })(caseDetails);

  const [planBlurred, setBlurPlan] = useState(false);
  const [issueTypeLabel, setIssueTypeLabel] = useState<HTMLLabelElement | null>();
  const [planLabel, setPlanLabel] = useState<HTMLLabelElement | null>();
  const [typeLabel, setTypeLabel] = useState<HTMLLabelElement | null>();
  const [accidentLabel, setAccidentLabel] = useState<HTMLLabelElement | null>();
  const [sicknessLabel, setSicknessLabel] = useState<HTMLLabelElement | null>();
  const [benefitPeriodLabel, setBenefitPeriodLabel] = useState<HTMLLabelElement | null>();
  const [situsStateLabel, setSitusStateLabel] = useState<HTMLLabelElement | null>();
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const showPlanError = planBlurred && plan.key === 'Empty';
  let {situsState, userAuthorizedJStamp} = caseDetails as ValidGroupCaseDetails;

  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;

  const getHeader = (header1: string, header2: string) => {
    return (
      <>
        <div className="disability-section__sub-title-container">
          <Typography variant="subtitle2" color="primary" className="disability-section__sub-title-container-title">
            {header1}
          </Typography>
        </div>
        {header2 !== '' ? (
          <div className="disability-section__sub-title-container">
            <Typography variant="subtitle2" color="primary" className="disability-section__sub-title-container-title">
              {header2}
            </Typography>
          </div>
        ) : null}
      </>
    );
  };

  const bindPackageDependentFields = (packageItem: object) => {
    dispatch(DActions.changeType('Employee'));
    dispatch(DActions.changeIssueType('SI'));
    dispatch(DActions.changeFMDR1Rider(packageItem['fmla'] === 'N' ? false : true));
    dispatch(DActions.changeSADRRider(packageItem['survivorAndAccident'] === 'N' ? false : true));
    dispatch(DActions.changeIBDR1Rider(packageItem['increasingBenPd'] === 'N' ? false : true));
    dispatch(DActions.changeOADR1Rider(packageItem['onTheJobAccident'] === 'N' ? false : true));
    dispatch(DActions.changeGCROPRRider(packageItem['returnOfPrem'] === 'N' ? false : true));

    //  Binding Benefit Period

    let benPeriod = '';
    const benefitPeriodItem = packageItem['benefitPeriod'];

    if (benefitPeriodItem !== null) {
      if (benefitPeriodItem === '3 months') {
        benPeriod = '003';
        dispatch(DActions.changeBenefitPeriod(benPeriod));
      } else if (benefitPeriodItem === '6 months') {
        benPeriod = '006';
        dispatch(DActions.changeBenefitPeriod(benPeriod));
      } else if (benefitPeriodItem === '12 months') {
        benPeriod = '012';
        dispatch(DActions.changeBenefitPeriod(benPeriod));
      } else if (benefitPeriodItem === '24 months') {
        benPeriod = '024';
        dispatch(DActions.changeBenefitPeriod(benPeriod));
      }
    }
    //  Binding Accident values

    let accidentDays = '';
    let sicknessDays = '';

    const eliminationPeriod = packageItem['eliminationPeriod'];

    let eliminationPeriodArray = [];

    if (eliminationPeriod !== null) {
      eliminationPeriodArray = eliminationPeriod.split('/');

      const accidentPart = eliminationPeriodArray[0].replace(/\D/g, '');
      const sicknessPart = eliminationPeriodArray[1].replace(/\D/g, '');

      if (accidentPart === '0') {
        accidentDays = '000';
        dispatch(DActions.changeAccident(accidentDays));
      } else if (accidentPart === '7') {
        accidentDays = '007';
        dispatch(DActions.changeAccident(accidentDays));
      } else if (accidentPart === '14') {
        accidentDays = '014';
        dispatch(DActions.changeAccident(accidentDays));
      } else if (accidentPart === '30') {
        accidentDays = '030';
        dispatch(DActions.changeAccident(accidentDays));
      } else if (accidentPart === '90') {
        accidentDays = '090';
        dispatch(DActions.changeAccident(accidentDays));
      } else if (accidentPart === '180') {
        accidentDays = '180';
        dispatch(DActions.changeAccident(accidentDays));
      }

      if (sicknessPart === '7') {
        sicknessDays = '007';
        dispatch(DActions.changeSickness(sicknessDays));
      } else if (sicknessPart === '14') {
        sicknessDays = '014';
        dispatch(DActions.changeSickness(sicknessDays));
      } else if (sicknessPart === '30') {
        sicknessDays = '030';
        dispatch(DActions.changeSickness(sicknessDays));
      } else if (sicknessPart === '90') {
        sicknessDays = '090';
        dispatch(DActions.changeSickness(sicknessDays));
      } else if (sicknessPart === '180') {
        sicknessDays = '180';
        dispatch(DActions.changeSickness(sicknessDays));
      }
    }
  };

  return (
    <div className="disability-section" id="group-disability-section">
      <form noValidate autoComplete="off" className="disability-section__form">
        <div className="disability-section__form-row">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <FormControl error={showPlanError} variant="outlined" className="disability-section__form-text-field">
                <InputLabel ref={setPlanLabel} id="disability-plan-label">
                  Plan
                </InputLabel>
                <Select
                  labelId="disability-label-plan"
                  labelWidth={planLabel?.clientWidth}
                  id="disability-plan"
                  value={plan.key === 'Empty' ? '' : plan.value}
                  onBlur={() => setBlurPlan(true)}
                  onChange={e => {
                    dispatch(DActions.changePlan('GVDIP'));

                    if (e.target.value === 'GVDIP') {
                      const PlanObj: Plan = {};
                      PlanObj.life70Name = 'GVDI';
                      PlanObj.name = 'GVDIP';
                      dispatch(DActions.getSaldOccClass(
                        caseNumber.key === 'Loaded'
                        ? caseNumber.Data
                        : caseNumber.key === 'UserAssignedCaseNumber'
                        ? caseNumber.value
                        : '', 
                        PlanObj));
                    }
                    dispatch(DActions.getPackageSourceList(
                      caseNumber.key === 'Loaded'
                          ? caseNumber.Data
                          : caseNumber.key === 'UserAssignedCaseNumber'
                          ? caseNumber.value
                          : '', 
                      'GVDIP'));
                  }}
                  displayEmpty
                >
                  {D.plans.map((plan: {name: string; displayName: string}, index: number) => (
                    <MenuItem value={plan.name} key={`disability-product-${plan.name}-${index}`}>
                      {plan.displayName}
                    </MenuItem>
                  ))}
                </Select>
                {showPlanError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>

          {plan.key === 'NonEmpty' && (
            <>
              <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                  <PackageSelect
                    packageName={packageSource}
                    packageList={packageSourceList}
                    changePackageAction={DActions.changePackageSource}
                    handlePackageItems={(packageItem: object) => {
                      bindPackageDependentFields(packageItem);
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="disability-section__form-text-field">
                    <InputLabel ref={setIssueTypeLabel} id="disability-issuetype-label">
                      Issue Type
                    </InputLabel>
                    <Select
                      labelId="disability-label-issuetype"
                      labelWidth={issueTypeLabel?.clientWidth}
                      id="disability-issuetype"
                      value={issueType.value}
                      onChange={e => dispatch(DActions.changeIssueType(e.target.value as string))}
                      displayEmpty
                    >
                      <MenuItem value="SI">SI</MenuItem>
                      <MenuItem value="GI">GI</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="disability-section__form-text-field">
                    <InputLabel ref={setTypeLabel} id="disability-type-label">
                      Type
                    </InputLabel>
                    <Select
                      labelId="disability-label-type"
                      labelWidth={typeLabel?.clientWidth}
                      id="disability-type"
                      value={type.value}
                      onChange={e => dispatch(DActions.changeType(e.target.value as string))}
                      displayEmpty
                      disabled
                    >
                      <MenuItem value="Employee">Employee</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {getHeader('Elimination Period', '')}

              <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="disability-section__form-text-field">
                    <InputLabel ref={setAccidentLabel} id="disability-accident-label">
                      Accident
                    </InputLabel>
                    <Select
                      labelId="disability-label-accident"
                      labelWidth={accidentLabel?.clientWidth}
                      id="disability-accident"
                      value={accident.key === 'Empty' ? '' : accident.value}
                      onChange={e => dispatch(DActions.changeAccident(e.target.value as string))}
                      displayEmpty
                    >
                      <MenuItem value="000">000</MenuItem>
                      <MenuItem value="007">007</MenuItem>
                      <MenuItem value="014">014</MenuItem>
                      <MenuItem value="030">030</MenuItem>
                      <MenuItem value="090">090</MenuItem>
                      <MenuItem value="180">180</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="disability-section__form-text-field">
                    <InputLabel ref={setSicknessLabel} id="disability-sickness-label">
                      Sickness
                    </InputLabel>
                    <Select
                      labelId="disability-label-sickness"
                      labelWidth={sicknessLabel?.clientWidth}
                      id="disability-sickness"
                      value={sickness.key === 'Empty' ? '' : sickness.value}
                      onChange={e => dispatch(DActions.changeSickness(e.target.value as string))}
                      displayEmpty
                    >
                      <MenuItem value="007">007</MenuItem>
                      <MenuItem value="014">014</MenuItem>
                      <MenuItem value="030">030</MenuItem>
                      <MenuItem value="090">090</MenuItem>
                      <MenuItem value="180">180</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {getHeader('Benefit', '')}

              <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="disability-section__form-text-field">
                    <InputLabel ref={setBenefitPeriodLabel} id="disability-period-label">
                      Period
                    </InputLabel>
                    <Select
                      labelId="disability-label-period"
                      labelWidth={benefitPeriodLabel?.clientWidth}
                      id="disability-period"
                      value={benefitPeriod.key === 'Empty' ? '' : benefitPeriod.value}
                      onChange={e => dispatch(DActions.changeBenefitPeriod(e.target.value as string))}
                      displayEmpty
                      disabled
                    >
                      <MenuItem value="003">003</MenuItem>
                      <MenuItem value="006">006</MenuItem>
                      <MenuItem value="012">012</MenuItem>
                      <MenuItem value="024">024</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="disability-monthly-benefit"
                    label="Monthly:$"
                    variant="outlined"
                    placeholder="Monthly:$"
                    margin="normal"
                    fullWidth
                    className="disability-section__form-text-field"
                    value={monthlyBenefit.value}
                    onChange={e => dispatch(DActions.changeBenefitMonthly(e.target.value as string))}
                  />
                </Grid>
              </Grid>

              {getHeader('Riders', '')}

              <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={gcroprRider}
                        onChange={() => dispatch(DActions.changeGCROPRRider(!gcroprRider))}
                        name="checkedGCROPR"
                      />
                    }
                    label={<Typography>GCROPR</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={oadr1Rider}
                        onChange={() => dispatch(DActions.changeOADR1Rider(!oadr1Rider))}
                        name="checkedB"
                      />
                    }
                    label={<Typography>OADR1</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={fmdr1Rider}
                        onChange={() => dispatch(DActions.changeFMDR1Rider(!fmdr1Rider))}
                        name="checkedB"
                      />
                    }
                    label={<Typography>FMDR1</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={ibdr1Rider}
                        onChange={() => dispatch(DActions.changeIBDR1Rider(!ibdr1Rider))}
                        name="checkedB"
                      />
                    }
                    label={<Typography>IBDR1</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={sadrRider}
                        onChange={() => dispatch(DActions.changeSADRRider(!sadrRider))}
                        name="checkedB"
                      />
                    }
                    label={<Typography>SADR1</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
              </Grid>
              {getHeader('Additional Information', '')}

              <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="disability-section__form-text-field">
                    <InputLabel ref={setSitusStateLabel} id="disability-situs-state-label">
                      Situs State
                    </InputLabel>
                    <Select
                      labelId="disability-label-situs-state"
                      labelWidth={situsStateLabel?.clientWidth}
                      id="disability-situs-state"
                      value={situsState.value || disability.situsState.value}
                      onChange={e => {
                        dispatch(DActions.changeSitusState(e.target.value as string));
                        dispatch(getSitusStatefromCaseNumber(''));
                      }}
                      displayEmpty
                    >
                      {States.map(stateCode => (
                        <MenuItem key={stateCode} value={stateCode}>
                          {stateCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="disability-monthly-salary"
                    label="Monthly Salary"
                    variant="outlined"
                    placeholder="Monthly Salary"
                    margin="normal"
                    fullWidth
                    className="disability-section__form-text-field"
                    value={monthlySalary.key === 'Empty' ? '' : monthlySalary.value}
                    onChange={e => dispatch(DActions.changeMonthlySalary(e.target.value as string))}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="disability-premium"
                    label="Premium"
                    variant="outlined"
                    placeholder="Enter Premium"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={calculatedPremium.key === 'Empty' ? '' : calculatedPremium.value}
                    onChange={event => {
                      dispatch(DActions.changePremium(event.target.value as string));
                      dispatch(DActions.changeCalculatedPremium(event.target.value as string));
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB"
                        color="secondary"
                        id="disability-section125"
                        checked={section125}
                        onChange={() => dispatch(DActions.changeSection125(!section125))}
                      />
                    }
                    label={<Typography>Section 125</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="disability-cwa"
                    label="CWA"
                    variant="outlined"
                    placeholder="CWA"
                    margin="normal"
                    fullWidth
                    className="disability-section__form-text-field"
                    value={cwa.key === 'Empty' ? '' : cwa.value}
                    onChange={e => dispatch(DActions.changeCWA(e.target.value as string))}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB"
                        color="secondary"
                        id="diability-replacement"
                        checked={replacement}
                        onChange={() => dispatch(DActions.changeReplacement(!replacement))}
                      />
                    }
                    label={<Typography>Replacement</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="disability-policy-number"
                    label="Policy Number"
                    variant="outlined"
                    placeholder="Enter Policy Number"
                    margin="normal"
                    fullWidth
                    error={showPolicyNumberError}
                    helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                    className="disability-section__form-text-field"
                    value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                    onBlur={() => setPolicyNumberBlurred(true)}
                    onChange={e => dispatch(DActions.changePolicyNumber(e.target.value as string))}
                    disabled={!replacement}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={jStamp}
                        onChange={() => dispatch(DActions.changeJStamp(!jStamp))}
                        name="checkedJStamp"
                        disabled={!userAuthorizedJStamp}
                      />
                    }
                    label={<Typography>J-Stamp</Typography>}
                    className="disability-section__form-text-field"
                  />
                </Grid>
              </Grid>
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default GroupDisability;

function matchCaseNumberByType(arg0: {Group: (groupApplication: any) => any; _: () => UnassignedCaseNumber}) {
  throw new Error('Function not implemented.');
}
